import { createReducer, on } from '@ngrx/store';

import { clearValidResetUser, errorValidResetUser, successValidResetUser, validResetUser } from '../actions';

export interface ReserUserState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    code: number;
}


export const ReserUserInit: ReserUserState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    code: 0,
}

const _resetUserReducer = createReducer(
    ReserUserInit,
    on(validResetUser, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successValidResetUser, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            code: data[0].code,
        }
    )),
    on(errorValidResetUser, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(clearValidResetUser, state => ({ ...state, ...ReserUserInit })),
);

export function ResetUserReducer(state: any, action: any) {
    return _resetUserReducer(state, action);
}
